// import ListItem from '@mui/material/ListItem';
import { Box, Button, Typography } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import {
  DetailedHTMLProps,
  FC,
  LiHTMLAttributes,
  MouseEventHandler,
  PropsWithChildren,
  ReactElement,
} from "react";

import { Nullable } from "web/types/Utils";

export interface IActivityItemProps
  extends Omit<
    DetailedHTMLProps<LiHTMLAttributes<HTMLLIElement>, HTMLLIElement>,
    "onClick"
  > {
  name: string;
  description: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  additionalElement?: ReactElement;
  disabled?: boolean;
  loading?: boolean;
  receiverName?: string;
  receiverLastname?: string;
  receiverEmail?: Nullable<string>;
}

export type ActivityItemProps = PropsWithChildren<IActivityItemProps>;

const ActivityItemMUI: FC<ActivityItemProps> = ({
  children,
  name,
  description,
  onClick,
  additionalElement,
  disabled = false,
  loading = false,
  receiverName,
  receiverLastname,
  receiverEmail,
}) => {
  return (
    <ListItem
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        border: "1px solid #E0E0E0",
        borderRadius: "15px",
        px: 2,
        py: 1,
        pb: 2,
        mb: 2,
      }}
    >
      <Box>
        <Typography variant="subtitle1">{name}</Typography>
        {receiverName && receiverLastname && (
          <Typography variant="body2">{`${receiverName} ${receiverLastname}`}</Typography>
        )}
        {receiverEmail && !receiverName && (
          <Typography variant="body2">{`${receiverEmail}`}</Typography>
        )}
      </Box>
      <Box>
        <Typography variant="body2">{description}</Typography>
        {additionalElement}
      </Box>
      <Box
        sx={{
          width: "100%",
          mt: 2,
        }}
      >
        <Button
          variant="outlined"
          color="inherit"
          size="large"
          onClick={onClick}
          disabled={disabled}
          loading={loading}
        >
          {children}
        </Button>
      </Box>
    </ListItem>
  );
};

export default ActivityItemMUI;
